import { useSearchParams } from 'react-router-dom';
import { useTranslations } from 'use-intl';
import { LoginLayout } from '@/routes/trainee/login-layout';

export function LoginError() {
  const [params] = useSearchParams();
  const t = useTranslations('login');
  return (
    <LoginLayout>
      <div className="p-8 text-center">
        <p className="text-lg">{t('bad_link')}</p>
        <br />
        <p>{params.get('message') ?? ''}</p>
      </div>
    </LoginLayout>
  );
}
